import campaignConfig from '../../../../campaign-config/campaign.json';

export const globalColors = campaignConfig.global?.colors || {};
export const globalBackgrounds = campaignConfig.global?.backgrounds || {};
export const globalText = campaignConfig.global?.text || {};

export const tutorDetailsLeaderboardConfig =
	campaignConfig.tutor_details?.leaderboard || {};

export const resolveTutorDetailsLeaderboardAsset = (asset) => asset;